export const COLUMNS =[
    {
        Header      : '#',
        accessor    : 'orgCode',
        Cell            : e=><div className="text-center">{e.value}</div>,
        disableFilters:true
    },
    {
        Header      : 'Organization Name',
        accessor    : 'orgName',
    },
    {
        Header      : 'Type of Certification',
        accessor    : 'typeOfCertification',
        disableFilters:true
    },
    {
        Header      : 'Audit Plan',
        accessor    : 'auditplanlist',
        Cell            : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/view/stage2auditplan/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    {
        Header      : 'Audit Report',
        accessor    : 'auditreportlist',
        // Cell        : e=><div className="text-center"><a href={'/admin/roi/listroi'}> {'View'} </a></div>,
        Cell        : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/view/auditreport/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    {
        Header      : 'CDC deliberation & decision',
        accessor    : 'cdclist',
        Cell        : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/view/certificatedeccommittee/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    }, 
    {
        Header      : 'Team Lead Approval',
        accessor    : 'teamleadapproval',
        // Cell        : e=><div className="text-center"><a href={'/admin/roi/listroi'}> {'View'} </a></div>,
        Cell        : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/viewapprovalofteamleader/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    {
        Header      : 'Review Of Audit',
        accessor    : 'reviewprocesslist',
        Cell            : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/view/stage2reviewofaudit/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    
    {
        Header      : 'Corrective Action',
        accessor    : 'correctiveactionlist',
        // Cell        : e=><div className="text-center"><a href={'/admin/roi/listroi'}> {'View'} </a></div>,
        Cell        : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/view/correctiveactionreport/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    {
        Header      : 'Audit Observation',
        accessor    : 'stagetwoauditobservationlist',
        // Cell        : e=><div className="text-center"><a href={'/admin/roi/listroi'}> {'View'} </a></div>,
        Cell        : e=><div className="text-center"><a href={'/'+(localStorage.getItem('role') === 'admin' ? 'admin' : 'user')+'/view/stage2auditobservationsheet/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    {
        Header      : 'Audit Report(Iso 27001)',
        accessor    : 'auditreportiso27001list',
        Cell        : e=><div className="text-center"><a href={'/admin/viewofstage1auditReportiso27001/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    {
        Header      : 'Ems Report',
        accessor    : 'emsstage2auditreportlist',
        // Cell        : e=><div className="text-center"><a href={'/admin/ViewofEmsStage1AuditReport/'+(e.value).split("-")[1]}> {'View'} </a></div>,
       // Cell        : e=><div className="text-center"><a href={'/admin/viewofstage1auditReport/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    {
        Header      : 'Ohsms Report',
        accessor    : 'ohsmsstage2auditreportlist',
       // Cell        : e=><div className="text-center"><a href={'/admin/viewofstage1auditReport/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
    {
        Header      : 'IMS All Report',
        accessor    : 'imsallstage2auditreportlist',
      //  Cell        : e=><div className="text-center"><a href={'/admin/Viewofimsnew90011400145001stage2auditreport/'+(e.value).split("-")[1]}> {'View'} </a></div>,
        disableFilters:true
    },
]